import { Button, Chip, Grid } from '@mui/material';
import { FormikValues } from 'formik';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { useDialog } from '../../../hooks';
import { AppealsConfirmDialog, AppealsDeclineDialog, AppealsDialog } from '../../appeals';
import { ApplicationsDeclineDialog, ApplicationsDialog } from '../../applications';
import { AttestationsEditDialog, AttestationsInfoDialog } from '../../attestations';
import { Page } from '../../page';
import { ConfirmDialog } from '../confirm-dialog';

export const DialogsPage: ComponentType = () => {
  const { t } = useTranslation();
  const [openConfirmation, closeConfirmation] = useDialog(ConfirmDialog);
  const [openApplicationDecline, closeApplicationDecline] = useDialog(ApplicationsDeclineDialog);
  const [openAppealConfirm, closeAppealConfirm] = useDialog(AppealsConfirmDialog);
  const [openAppealDecline, closeAppealDecline] = useDialog(AppealsDeclineDialog);
  const [openApplication] = useDialog(ApplicationsDialog);
  const [openAppeal] = useDialog(AppealsDialog);
  const [openAttestationInfo] = useDialog(AttestationsInfoDialog);
  const [openAttestationAdd, closeAttestationAdd] = useDialog(AttestationsEditDialog);

  const userName = 'Махкамов Рахим Каримович';

  const positive: any = {
    success: t('action.confirm', 'Одобрить'),
    error: t('action.decline', 'Отклонить'),
    warning: t('action.edit', 'Редактировать'),
  };

  const handleConfirmation = (variant: 'success' | 'info' | 'warning' | 'error' = 'error') => {
    openConfirmation({
      text: 'Вы уверены, что хотите удалить ноду?',
      size: 'small',
      variant,
      positive: positive[variant] ? positive[variant] : null,
      resolve: () => {
        closeConfirmation();
      },
      reject: () => {
        console.log('confirmation rejected');
      },
    });
  };

  const handleApproveApp = () => {
    openConfirmation({
      title: t('application.confirm.title', 'Одобрить заявку'),
      text: t(
        'application.confirm.text',
        `Вы точно хотите одобрить заявку пользователя ${userName}?`,
        { userName }
      ),
      size: 'small',
      variant: 'success',
      positive: t('action.confirm', 'Одобрить'),
      resolve: () => {
        closeConfirmation();
      },
      reject: () => {
        console.log('application rejected');
      },
    });
  };

  const handleRejectApp = () => {
    openApplicationDecline({
      title: t('application.decline.title', 'Отклонить заявку'),
      text: t(
        'application.decline.text',
        `Вы точно хотите отклонить заявку пользователя ${userName}?`,
        { userName }
      ),
      size: 'small',
      onSubmit: (values: FormikValues) => {
        closeApplicationDecline();
      },
    });
  };

  const handleApproveAppeal = () => {
    openAppealConfirm({
      title: t('appeal.confirm.title', 'Одобрить апелляцию'),
      text: null,
      // t(
      //   'appeal.confirm.text',
      //   `Вы точно хотите принять заявку на апелляцию от пользователя ${userName}?`,
      //   { userName }
      // ),
      size: 'small',
      onSubmit: (values: FormikValues) => {
        closeAppealConfirm();
      },
    });
  };

  const handleRejectAppeal = () => {
    openAppealDecline({
      title: t('appeal.decline.title', 'Отклонить апелляцию'),
      text: t(
        'appeal.decline.text',
        `Вы точно хотите отклонить заявку на апелляцию от пользователя ${userName}?`,
        { userName }
      ),
      size: 'small',
      onSubmit: (values: FormikValues) => {
        closeAppealDecline();
      },
    });
  };

  const handleApplication = () => {
    openApplication({
      statuses: (
        <>
          <Chip label="Ожидание одобрения" color="warning" />
          <Chip label="Ожидание оплаты" color="warning" />
        </>
      ),
      title: 'Заявка на аттестацию №836',
      text: '«Аттестация руководителей и работников подразделений государственных органов и иных бюджетных организаций, ответственных за развитие информационных технологий и коммуникаций»',
      startDate: '1 ноября 2021',
      startTime: '9:00 - 10:00',
      location: 'г. Ташкент, Юнусабадский район, ул. Амира Темура 7',
      createdFullDate: '12 сентября 2021',
    });
  };

  const handleAppeal = () => {
    openAppeal({
      title: 'Заявка на апелляцию №36',
      size: 'large',
      resolve: () => {
        closeConfirmation();
      },
      reject: () => {
        closeConfirmation();
      },
    });
  };

  const handleAttestationsInfo = () => {
    openAttestationInfo({
      title: t('attestations.info', 'Информация об аттестации'),
      text: '«Аттестация руководителей и работников подразделений государственных органов и иных бюджетных организаций, ответственных за развитие информационных технологий и коммуникаций»',
      startDate: '1 ноября 2021',
      startTime: '9:00 - 10:00',
      location: 'г. Ташкент, Юнусабадский район, ул. Амира Темура 7',
      total: 15,
      left: 5,
    });
  };

  const handleAttestationsAdd = () => {
    openAttestationAdd({
      title: t('attestations.add', 'Добавить аттестацию'),
      onSubmit: (values: FormikValues) => {
        closeAttestationAdd();
      },
    });
  };

  return (
    <Page title={t('instruction', 'Инструкция')}>
      <Grid container spacing={2} mb={2}>
        <Grid item>
          <Button onClick={() => handleConfirmation('error')} variant="contained" color="error">
            {t('confirmation', 'Подтверждение')}
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={() => handleConfirmation('success')} variant="contained" color="success">
            {t('confirmation', 'Подтверждение')}
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={() => handleConfirmation('info')} variant="contained" color="info">
            {t('confirmation', 'Подтверждение')}
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={() => handleConfirmation('warning')} variant="contained" color="warning">
            {t('confirmation', 'Подтверждение')}
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2} mb={2}>
        <Grid item>
          <Button onClick={handleRejectApp} variant="contained" color="error">
            Отклонить заявку
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={handleApproveApp} variant="contained" color="success">
            Одобрить заявку
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2} mb={2}>
        <Grid item>
          <Button onClick={handleRejectAppeal} variant="contained" color="error">
            Отклонить аппеляцию
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={handleApproveAppeal} variant="contained" color="success">
            Одобрить аппеляцию
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2} mb={2}>
        <Grid item>
          <Button onClick={handleApplication} variant="contained" color="primary">
            Детальная заявки
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={handleAppeal} variant="contained" color="success">
            Детальная апелляции
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2} mb={2}>
        <Grid item>
          <Button onClick={handleAttestationsInfo} variant="contained" color="info">
            Информация об аттестации
          </Button>
        </Grid>
        <Grid item>
          <Button onClick={handleAttestationsAdd} variant="contained" color="primary">
            Добавить аттестацию
          </Button>
        </Grid>
      </Grid>
    </Page>
  );
};
